/*eslint-disable*/
import api from '../'

class alphabetGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/alphabet/items', { params }).then(response => response.data.items);
    }
}

export default alphabetGameItems;
